const getMetaByWidgetType = (widget) => {
  if (widget === 'search') {
    return findify.grid.state.meta
  }
  if (widget === 'autocomplete') {
    return findify.autocomplete.state.meta
  }
  if (widget.includes('findify-rec')) {
    return findify.recommendation.state[widget]?.response?.meta
  }
  throw new Error(`there is no meta for widget type : ${widget}`)
}

const initProductCardAnalytics = (id, properties) => {
  const meta = getMetaByWidgetType(properties.widget)

  try {
    findify.core.analytics?.sendEvent('click-item', {
      rid: meta.rid,
      item_id: id,
      variant_item_id: properties.selected_variant_id
    })
  } catch (error) {
    console.log('error', error)
  }
}

const initOnProductCardClick = (id, properties) => {
  document.getElementById(id).addEventListener('click', (e) => {
    initProductCardAnalytics(id, properties)
  })
}

const initProductAddToCart = (id) => {
  const addToCartButton = document.getElementById(id).querySelector('form')
  if (addToCartButton) {
    addToCartButton.addEventListener('submit', function (e) {
      e.preventDefault()
      const button = this.querySelector('.btn-add-to-cart')
      button.classList.add('loading')
      let formData = {
        items: [
          {
            id: this.id.value,
            quantity: 1,
            properties: {}
          }
        ]
      }

      const $pdpBadges = document.getElementById(id).querySelectorAll('.product-badges')
      const promoLabel = $pdpBadges[0]?.dataset.promoDescription
      const promoFinshTime = $pdpBadges[0]?.dataset.promoFinishTime

      if (promoLabel && promoFinshTime) {
        formData.items[0].properties._promoData = JSON.stringify({
          label: promoLabel,
          finishTime: promoFinshTime
        })
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((response) => {
          return response.json()
        })
        .catch((error) => {
          console.error('Error:', error)
        })
        .finally(() => {
          button.classList.remove('loading')
          emitter.emit('load:cart')
        })
    })
  }
}
